import { Routes } from '@angular/router';
import { AUTH_ROUTES } from './features/auth/auth.routes';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/main/main.routes').then(c => c.MAIN_ROUTES),
    providers: [],
  },
  ...AUTH_ROUTES,
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
